import { TabButtonPublicProp } from '@topconagriculture/react-components';

export const ProductsTabNames: TabButtonPublicProp[] = [
  { key: 'ingredients', label: 'products:ingredient_plural' },
  { key: 'recipes', label: 'products:recipe_plural' },
  { key: 'premixes', label: 'products:premix_plural' },
];

export const IngredientsTabNames: TabButtonPublicProp[] = [
  { key: 'general', label: 'products:general_data' },
  { key: 'inventory', label: 'products:inventory' },
  { key: 'advanced', label: 'products:advanced_settings' },
];

export const PremixesTabNames: TabButtonPublicProp[] = [
  { key: 'general', label: 'products:general_data' },
  { key: 'advanced', label: 'products:advanced_settings' },
];

export const RationCreationTabNames: TabButtonPublicProp[] = [
  { key: 'ingredients', label: 'products:ingredient_plural' },
  { key: 'premixes', label: 'products:premix_plural' },
];

export const FeedPensTabNames: TabButtonPublicProp[] = [
  { key: 'general', label: 'products:general_data' },
  { key: 'advanced', label: 'products:advanced_settings' },
];

export const MixersTabNames: TabButtonPublicProp[] = [
  { key: 'feedings', label: 'mixers:delivery_order' },
  { key: 'premixes', label: 'products:premix_plural' },
];

export const WeighbridgeTabNames: TabButtonPublicProp[] = [
  { key: 'open-tickets', label: 'inventory:open_tickets' },
  { key: 'archive', label: 'inventory:archive' },
];

export const MixersDetailTabNames: TabButtonPublicProp[] = [{ key: 'generalData', label: 'mixers:general_data' }];

export enum LoadersNames {
  fetchFarms = 'fetchFarms',
  fetchCompanyUserList = 'fetchCompanyUserList',
  patchFarm = 'patchFarm',
  changeFarm = 'changeFarm',

  fetchIngredients = 'fetchIngredients',
  getIngredient = 'getIngredient',
  createIngredient = 'createIngredient',
  editIngredient = 'editIngredient',
  editIngredientInventory = 'editIngredientInventory',
  renameIngredient = 'renameIngredient',
  getIngerdientsBatch = 'getIngerdientsBatch',
  getIngredientDailyUsage = 'getIngredientDailyUsage',

  fetchRecipes = 'fetchRecipes',
  getRecipe = 'getRecipe',
  createRecipe = 'createRecipe',
  editRecipe = 'editRecipe',
  previewRecipe = 'previewRecipe',
  renameRecipe = 'renameRecipe',

  fetchPremixes = 'fetchPremixes',
  getPremix = 'getPremix',
  createPremix = 'createPremix',
  editPremix = 'editPremix',
  previewPremix = 'previewPremix',
  renamePremix = 'renamePremix',

  fetchGroupList = 'fetchGroupList',
  fetchGroup = 'fetchGroup',

  addBunkReaderScore = 'addBunkReaderScore',

  fetchFeedingPeriods = 'fetchFeedingPeriods',
  fetchFeedingPeriodDetail = 'fetchFeedingPeriodDetail',
  addFeedingGroup = 'addFeedingGroup',
  fetchFeedingGroupTotals = 'fetchFeedingGroupTotals',
  updateFeedingPeriod = 'updateFeedingPeriod',

  createMixer = 'createMixer',
  editMixer = 'editMixer',
  fetchMixerList = 'fetchMixerList',
  fetchMixer = 'fetchMixer',
  getMixerStatus = 'getMixerStatus',
  fetchLoadList = 'fetchLoadList',
  fetchAllFeedingPeriodDetail = 'fetchAllFeedingPeriodDetail',
  sendFeedingLoadsToMixer = 'sendFeedingLoadsToMixer',
  fetchScaleTypes = 'fetchScaleTypes',

  createCompanyUser = 'createCompanyUser',

  fetchReport = 'fetchReport',
  fetchReportFilterData = 'fetchReportFilterData',
  fetchAutomatedReport = 'fetchAutomatedReport',
  downloadReport = 'downloadReport',
  downloadListReport = 'downloadListReport',
  downloadGateway = 'downloadGateway',
  fetchShares = 'fetchShares',
  fetchOperators = 'fetchOperators',
  createPreset = 'createPreset',

  addGroup = 'addGroup',
  editGroup = 'editGroup',

  updateItem = 'updateItem',
  deleteItem = 'deleteItem',

  fetchPreset = 'fetchPreset',

  fetchSettings = 'fetchSettings',
  updateSettings = 'updateSettings',
  fetchWeighBridgeSystems = 'fetchWeighBridgeSystems',
  fetchThirdParties = 'fetchThirdParties',

  fetchGroupTypes = 'fetchGroupTypes',
  addGroupType = 'addGroupType',
  deleteGroupType = 'deleteGroupType',
  editGroupType = 'editGroupType',

  fetchLoadsDeliveriesBatches = 'fetchLoadsDeliveriesBatches',
  fetchLoadsDeliveries = 'fetchLoadsDeliveries',
  updateLoadsDeliveries = 'updateLoadsDeliveries',
  deleteLoadDeliveryBatch = 'deleteLoadDeliveryBatch',

  fetchIngredientsPrices = 'fetchIngredientsPrices',
  updateIngredientPrice = 'updateIngredientPrice',
  addIngredientPrice = 'addIngredientPrice',

  fetchMilkings = 'fetchMilkings',

  fetchConcentrates = 'fetchConcentrates',

  fetchMilkPrices = 'fetchMilkPrices',
  createMilkPrice = 'createMilkPrice',
  updateMilkPrice = 'updateMilkPrice',
  deleteMilkPrice = 'deleteMilkPrice',

  fetchZones = 'fetchZones',
  editZone = 'editZone',

  fetchRecipeInBaseRation = 'fetchRecipeInBaseRation',

  fetchRefusalsBatches = 'fetchRefusalsBatches',
  updateRefusalsDelivery = 'updateRefusalsDelivery',
  fetchRefusals = 'fetchRefusals',
  fetchRefusalsSettings = 'fetchRefusalsSettings',

  getLots = 'getLots',
  getLotById = 'getLotById',
  createLot = 'createLot',
  updateLot = 'updateLot',
  updateLotMovements = 'updateLotMovements',
  updateLotAdditionalCosts = 'updateLotAdditionalCosts',
  updatePenAdditionalCosts = 'updatePenAdditionalCosts',
  addTransfers = 'addTransfers',
  getCloseoutPreview = 'getCloseoutPreview',
  downloadCloseoutReport = 'downloadCloseoutReport',
  addCloseouts = 'addCloseouts',
  fetchCostSummaryReport = 'fetchCostSummaryReport',

  getRelations = 'getRelations',
  createRelation = 'createRelation',

  getLotTypes = 'getLotTypes',
  createLotType = 'createLotType',

  getCostTypes = 'getCostTypes',
  createCostType = 'createCostType',

  getLotMarketTypes = 'getLotMarketTypes',
  createLotMarketType = 'createLotMarketType',

  getDeliveriesInLotCreation = 'getDeliveriesInLotCreation',
  getCustomers = 'getCustomers',

  getHerdManagementSystem = 'getHerdManagementSystem',

  getDriverPermissions = 'getDriverPermissions',
  updateDriverPermissions = 'updateDriverPermissions',

  deleteFeeding = 'deleteFeeding',

  schedulePremix = 'schedulePremix',
  getLoadMixersPremixes = 'getLoadMixersPremixes',

  addNote = 'addNote',
  deleteNote = 'deleteNote',
  editNote = 'editNote',

  previewLot = 'previewLot',

  updateDLCommunicationStarted = 'updateDLCommunicationStarted',

  resetFarm = 'resetFarm',

  getInventoryRequirements = 'getInventoryRequirements',
  fetchWeighBridgeTickets = 'fetchWeighBridgeTickets',

  fetchSubscriptions = 'fetchSubscriptions',

  fetchOrders = 'fetchOrders',
  fetchReceiveIngredient = 'fetchReceiveIngredient',
  createOrder = 'createOrder',
  updateRecord = 'updateRecord',
  deleteRecord = 'deleteRecord',

  previewPDF = 'previewPDF',
  sendLoadsdata = 'sendLoadsdata',

  getBinControlInits = 'getBinControlInits',
  saveBinControlUnitsForm = 'saveBinControlUnitsForm',
}

export enum TabsNames {
  productsPageTabs = 'productsPageTabs',
  rationCreationTabs = 'rationCreationTabs',
  mixersPageTabs = 'mixersPageTabs',
  mixerDetailTabs = 'mixerDetailTabs',
  weighbridgeTabs = 'weighbridgeTabs',
}

export enum SidebarNames {
  products = 'products',
  mixers = 'mixers',
}
